import { render, staticRenderFns } from "./SpaceMembersItem.vue?vue&type=template&id=b6a3b8e6&"
import script from "./SpaceMembersItem.vue?vue&type=script&lang=js&"
export * from "./SpaceMembersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports